import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { _Api, graphqlPost } from "../api/_call";
import TableColumnModal from "../common/modules/tableColumn";
import { Tablehead } from "../common/modules/Tablehead";
import { useReportSort } from "./useReportSort";
import { reportstocktakelisthead } from "../common/Tablehead";
import { ReportMenuModal } from "../common/modules/reportMenu";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SocialModal from "../common/modules/SocialModal/SocialModal";
import { Pagination } from "../common/Pagination";
import {
  error,
  loading,
  success,
  Updateloading,
} from "../common/helpers/toastify";
import { useTranslation } from "react-i18next";
import * as FileSaver from "file-saver";
import { useSelector } from "react-redux";
import Select from "react-select";
import * as XLSX from "xlsx";
import RFIDIcon from "Icons/RFIDIcon";
import manualScan from "../../assets/images/manual-scan.png";
import "../common/multi-select/multiSelect.scss";
import "./report.scss";

const SELECT_ALL_LOCATION_VALUE = "*";

/** Stock Take report only — multi location select (not shared commonlayouts). */
const StockTakeLocationSelect = ({ value = [], onChange }) => {
  const dataFetched = useRef(false);
  const [locationOptions, setLocationOptions] = useState([]);

  useEffect(() => {
    if (dataFetched.current) return;
    dataFetched.current = true;
    (async () => {
      try {
        const response = await graphqlPost(`{
          locations {
            id
            name
          }
        }`);
        const options = (response?.data?.locations || [])
          .filter((loc) => loc?.id && loc?.name)
          .map((loc) => ({ value: loc.id, label: loc.name }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setLocationOptions([
          { value: SELECT_ALL_LOCATION_VALUE, label: "Select All" },
          ...options,
        ]);
      } catch (err) {
        console.log(err, "err");
      }
    })();
  }, []);

  const handleChange = (selected) => {
    const next = selected || [];
    if (next.some((opt) => opt.value === SELECT_ALL_LOCATION_VALUE)) {
      onChange(
        locationOptions.filter(
          (opt) => opt.value !== SELECT_ALL_LOCATION_VALUE,
        ),
      );
      return;
    }
    onChange(next);
  };

  return (
    <Select
      placeholder="Select Store"
      options={locationOptions}
      value={value}
      onChange={handleChange}
      classNamePrefix="product-multi-select"
      isSearchable
      isMulti
      filterOption={(option, searchText) =>
        option.label.toLowerCase().includes(searchText.toLowerCase())
      }
      menuPlacement="bottom"
      menuPosition="fixed"
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
        menuList: (base) => ({
          ...base,
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }),
      }}
      formatOptionLabel={(e) => (
        <div className="product-multi-select__multi-value__label-ct">
          <span>{e.label}</span>
        </div>
      )}
    />
  );
};

const Stocktakereport = (props) => {
  const { t } = useTranslation();
  const [rfidIntegrate, setRfidIntegrate] = useState(false);
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const stickyTopRef = useRef(null);
  const tableHeadScrollRef = useRef(null);
  const tableBodyScrollRef = useRef(null);
  const tableHeadTableRef = useRef(null);
  const tableBodyTableRef = useRef(null);
  const tableScrollSyncLock = useRef(false);
  const [limit, setLimit] = useState(100);
  const [socialurl, setSocialurl] = useState();
  const [filtername, setFiltername] = useState("");
  const [reportstocktakelist, setReportstocktakelist] = useState();
  const reportSort = useReportSort(reportstocktakelist, [null, (r) => r?.date, null, (r) => r?.st_no, (r) => r?.location, (r) => r?.total, (r) => r?.scanned, (r) => r?.unscanned, (r) => r?.conflictAndUnknown, (r) => r?.user_name, null]);
  const [state, setstate] = useState({
    totalPages: 0,
    currentPage: 1,
  });
  const { totalPages, currentPage } = state;
  const [datefilter, setDatefilter] = useState(() => {
    const s = new Date();
    s.setHours(0, 0, 0, 0);
    return [s, new Date()];
  });
  const [datelable, setDatelable] = useState("Today");
  const datePickerRef = useRef(null);
  const changeDates = (lable) => {
    const MainDate = new Date();
    if (lable === "Today") {
      const s = new Date();
      s.setHours(0, 0, 0, 0);
      setDatefilter([s, new Date()]);
      setDatelable("Today");
    } else if (lable === "Yesterday") {
      const s = new Date(MainDate.setDate(MainDate.getDate() - 1));
      s.setHours(0, 0, 0, 0);
      const e = new Date(s);
      e.setHours(23, 59, 59, 999);
      setDatefilter([s, e]);
      setDatelable("Yesterday");
    } else if (lable === "7days") {
      const s = new Date(MainDate.setDate(MainDate.getDate() - 7));
      s.setHours(0, 0, 0, 0);
      const e = new Date();
      e.setHours(23, 59, 59, 999);
      setDatefilter([s, e]);
      setDatelable("7days");
    } else if (lable === "30days") {
      const s = new Date(MainDate.setDate(MainDate.getDate() - 30));
      s.setHours(0, 0, 0, 0);
      const e = new Date();
      e.setHours(23, 59, 59, 999);
      setDatefilter([s, e]);
      setDatelable("30days");
    } else if (lable === "ThisMonth") {
      const s = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1);
      s.setHours(0, 0, 0, 0);
      const e = new Date(MainDate.getFullYear(), MainDate.getMonth() + 1, 0);
      e.setHours(23, 59, 59, 999);
      setDatefilter([s, e]);
      setDatelable("ThisMonth");
    } else if (lable === "LastMonth") {
      const s = new Date(MainDate.getFullYear(), MainDate.getMonth() - 1, 1);
      s.setHours(0, 0, 0, 0);
      const e = new Date(MainDate.getFullYear(), MainDate.getMonth(), 0);
      e.setHours(23, 59, 59, 999);
      setDatefilter([s, e]);
      setDatelable("LastMonth");
    }
  };
  const [newcolumndata, setnewcolumndata] = useState(reportstocktakelisthead);
  const [reportstockcounts, setReportstockcounts] = useState([]);
  const [shareloader, setShareloader] = useState(false);
  const [datalodaer, setDatsLodaer] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const locationVoucherMapRef = useRef({});
  const locationInlineSlotRef = useRef(null);
  const [locationOnSecondRow, setLocationOnSecondRow] = useState(false);
  const [syncRfidLoading, setSyncRfidLoading] = useState(false);
  // Screen position + label for source icons (RFID / Mobile / Manual).
  // Portal avoids DataTables scroll clipping the tooltip behind thead.
  const [sourceTooltip, setSourceTooltip] = useState(null);
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);

  // Keep calendar day stable in API payload (avoid IST midnight → previous UTC day)
  const toLocalApiDate = (date, endOfDay = false) => {
    if (!date) return "";
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    // return endOfDay
    //   ? `${y}-${m}-${day}T23:59:59.999Z`
    //   : `${y}-${m}-${day}T00:00:00.000Z`;
    return endOfDay ? `${y}-${m}-${day}` : `${y}-${m}-${day}`;
  };

  // Map location_id -> Stock_Take voucher_id (same voucher group as Stock Take screen)
  const getStockTakeVoucherByLocation = async () => {
    const locationToVoucher = {};
    try {
      const vouchersRes = await graphqlPost(`{
        vouchers(group: "Stock_Take") {
          id
          name
        }
      }`);
      const vouchers = vouchersRes?.data?.vouchers || [];
      for (const voucher of vouchers) {
        if (!voucher?.id) continue;
        try {
          const voucherDetail = await graphqlPost(`{
            voucherById(id: "${voucher.id}") {
              id
              locations {
                id
                name
              }
            }
          }`);
          const locations = voucherDetail?.data?.voucherById?.locations || [];
          locations.forEach((loc) => {
            if (loc?.id) {
              locationToVoucher[loc.id] = voucher.id;
            }
          });
        } catch (err) {
          console.log(err, "err");
        }
      }
      // If a location is not linked on any voucher, fall back to first Stock_Take voucher
      if (vouchers[0]?.id) {
        locationToVoucher.__default = vouchers[0].id;
      }
    } catch (err) {
      console.log(err, "err");
    }
    return locationToVoucher;
  };

  const loadLocationVoucherMap = async () => {
    locationVoucherMapRef.current = await getStockTakeVoucherByLocation();
  };

  useEffect(() => {
    loadLocationVoucherMap();
  }, []);

  // Keep location on row 1 until selected chips no longer fit that width → move to row 2
  useEffect(() => {
    const updateLocationRow = () => {
      const names = (selectedLocations || [])
        .map((loc) => loc?.label)
        .filter(Boolean);
      const slot = locationInlineSlotRef.current;
      const bar = slot?.closest(".main-body-top-status-bar");

      let slotWidth = slot?.clientWidth || 0;
      // When location is on row 2 the inline slot is collapsed — estimate row-1 free width
      if (bar && (locationOnSecondRow || slotWidth < 80)) {
        const right = bar.querySelector(
          ".main-body-top-status-bar-multi-date-picker",
        );
        let used = 0;
        Array.from(bar.children).forEach((child) => {
          if (child === slot) return;
          used += child.getBoundingClientRect().width + 10;
        });
        slotWidth = Math.max(bar.clientWidth - used, 160);
      }

      if (!names.length || names.length === 1) {
        setLocationOnSecondRow(false);
        return;
      }

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        setLocationOnSecondRow(names.length > 2);
        return;
      }
      ctx.font = "14px Segoe UI, sans-serif";

      // pin + paddings + clear/chevron indicators
      let usedWidth = 90;
      for (const name of names) {
        usedWidth += ctx.measureText(name).width + 44;
      }

      setLocationOnSecondRow(usedWidth > slotWidth);
    };

    updateLocationRow();
    window.addEventListener("resize", updateLocationRow);
    return () => window.removeEventListener("resize", updateLocationRow);
  }, [selectedLocations, locationOnSecondRow]);

  const handleSyncRfid = async () => {
    if (!selectedLocations?.length) {
      error(t("Please select a location"));
      return;
    }
    if (!datefilter?.[0] || !datefilter?.[1]) {
      error(t("Please select a date range"));
      return;
    }

    const voucherMap = locationVoucherMapRef.current || {};
    const locationsWithVoucher = selectedLocations.map((loc) => ({
      ...loc,
      voucher_id: voucherMap[loc.value] || voucherMap.__default || null,
    }));
    const missingVoucher = locationsWithVoucher.filter(
      (loc) => !loc?.voucher_id,
    );
    if (missingVoucher.length) {
      error(t("Stock Take voucher not found for this location"));
      return;
    }

    const payload = {
      location_id: locationsWithVoucher.map((loc) => loc.value),
      location_ids: locationsWithVoucher.map((loc) => loc.value),
      sid: locationsWithVoucher.map((loc) => loc.label),
      voucher_id: locationsWithVoucher.map((loc) => loc.voucher_id),
      locations: locationsWithVoucher.map((loc) => ({
        location_id: loc.value,
        sid: loc.label,
        voucher_id: loc.voucher_id,
      })),
      fromDate: toLocalApiDate(datefilter[0], false),
      toDate: toLocalApiDate(datefilter[1], true),
    };

    setSyncRfidLoading(true);
    let GetloadingID = loading();
    try {
      let res = await _Api(
        payload,
        `api/v1/Inventory/stocktake/getRFIDStockList`,
      );
      if (res?.code === 200) {
        Updateloading(
          t,
          GetloadingID,
          res?.message || t("RFID synced successfully"),
        );
        Getreportstocktake(1, limit, filtername);
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message || res?.errors || t("Sync RFID failed"),
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Sync RFID failed"), "error");
    } finally {
      setSyncRfidLoading(false);
    }
  };
  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    Getreportstocktake(1, limit, search);
  };
  const getlimit = (nextLimit) => {
    setLimit(nextLimit);
    Getreportstocktake(1, nextLimit);
    setstate({ ...state, currentPage: 1 });
  };
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Getreportstocktake(current, "");
  };
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_report_stocktake",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    callcolumns();
  }, []);
  const getsharestocktake = async () => {
    setShareloader(true);
    try {
      const postdata = {
        search: filtername,
        start_date: datefilter ? toLocalApiDate(datefilter[0], false) : "",
        end_date: datefilter ? toLocalApiDate(datefilter[1], true) : "",
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/reports/print/stocktake`,
      );

      if (res.code === 200) {
        setSocialurl(res?.link);
        setShareloader(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getprintstocktake = async () => {
    let GetloadingID = loading();
    try {
      const postdata = {
        search: filtername,
        start_date: datefilter ? toLocalApiDate(datefilter[0], false) : "",
        end_date: datefilter ? toLocalApiDate(datefilter[1], true) : "",
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/reports/print/stocktake`,
      );
      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute("target", "_blank");
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));
        }, 50);
        setSocialurl(res?.link);
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message ? res?.message : res?.errors,
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err, t("error"));
    }
  };

  const parseDateTime = (dateStr, timeStr) => {
    if (!dateStr) return 0;
    const [day, month, year] = dateStr.split("/").map(Number);
    let hours = 0,
      minutes = 0,
      seconds = 0;
    if (timeStr) {
      [hours, minutes, seconds] = timeStr.split(":").map(Number);
    }
    return new Date(
      year,
      month - 1,
      day,
      hours || 0,
      minutes || 0,
      seconds || 0,
    ).getTime();
  };

  // Same style as User Log: date + "06:58:39 pm"
  const formatStockTakeDateTimeParts = (dateStr, timeStr) => {
    if (!dateStr && !timeStr) return { date: "-", time: "" };

    const pad = (n) => String(n).padStart(2, "0");
    let datePart = dateStr || "";
    let timePart = "";

    const combined = [dateStr, timeStr].filter(Boolean).join(" ").trim();
    if (/\b(am|pm)\b/i.test(combined)) {
      const match = combined.match(/^(\d{1,2}\/\d{1,2}\/\d{4})[,\s]+(.+)$/i);
      if (match) {
        return { date: match[1], time: match[2].trim() };
      }
      return { date: combined, time: "" };
    }

    const [day, month, year] = String(dateStr || "")
      .split("/")
      .map(Number);
    if (day && month && year) {
      datePart = `${pad(day)}/${pad(month)}/${year}`;
    }

    if (timeStr) {
      const parts = String(timeStr).split(":").map(Number);
      const hours = parts[0] || 0;
      const minutes = parts[1] || 0;
      const seconds = parts[2] || 0;
      const ampm = hours >= 12 ? "pm" : "am";
      let hour12 = hours % 12;
      if (hour12 === 0) hour12 = 12;
      timePart = `${pad(hour12)}:${pad(minutes)}:${pad(seconds)} ${ampm}`;
    }

    return { date: datePart || "-", time: timePart };
  };

  const formatStockTakeDateTime = (dateStr, timeStr) => {
    const { date, time } = formatStockTakeDateTimeParts(dateStr, timeStr);
    return time ? `${date}, ${time}` : date;
  };

  const getStockTakeCountryCode = (row) => row?.country || "";

  const sortByDateDesc = (list) => {
    if (!Array.isArray(list)) return list;
    return [...list].sort(
      (a, b) =>
        parseDateTime(b?.date, b?.time) - parseDateTime(a?.date, a?.time),
    );
  };
  const Getreportstocktake = async (current, firstlimit, search) => {
    setDatsLodaer(true);
    const tablelimit = firstlimit ? firstlimit : limit;
    const skipNumber = current ? (current - 1) * (Number(tablelimit) || 0) : 0;
    try {
      const postdata = {
        search: search === "" ? search : (search || filtername || ""),
        limit: firstlimit ? firstlimit : limit,
        skip: skipNumber,
        start_date: datefilter ? toLocalApiDate(datefilter[0], false) : "",
        end_date: datefilter ? toLocalApiDate(datefilter[1], true) : "",
      };
      let res = await _Api(postdata, `api/v1/Inventory/report/stocktake`);
      if (res.code === 200) {
        const rows = sortByDateDesc(res?.data || []);
        const page = current ? Number(current) : 1;
        const pageini = Number(postdata.limit) || rows.length || 1;
        const hasApiTotal = res?.total !== undefined && res?.total !== null && res?.total !== "";
        setReportstocktakelist(rows);
        setReportstockcounts(res?.count);
        if (!rows.length && page > 1 && !hasApiTotal) {
          setstate((prev) => ({
            ...prev,
            totalPages: page - 1,
            currentPage: page - 1,
          }));
        } else {
          setstate((prev) => {
            let totalPages = 0;
            if (hasApiTotal) {
              totalPages = Math.ceil((Number(res?.total) || 0) / pageini) || 0;
            } else if (!rows.length) {
              totalPages = 0;
            } else if (rows.length < pageini) {
              totalPages = page;
            } else if (page === 1) {
              totalPages = 2;
            } else {
              totalPages = Math.max(prev.totalPages || 0, page + 1);
            }
            return { ...prev, totalPages, currentPage: page };
          });
        }
        setRfidIntegrate(res?.rfidIntegration?.status || false);

      } else {
        // "data not found" -> nothing in this range; clear the old rows
        setReportstocktakelist([]);
        setReportstockcounts([]);
        setstate((prev) => ({ ...prev, totalPages: 0, currentPage: 1 }));
      }
      setDatsLodaer(false);
    } catch (err) {
      setDatsLodaer(false);
      console.log(err, "err");
    }
  };

  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      Getreportstocktake();
    }
    // eslint-disable-next-line
  }, [datefilter]);

  useEffect(() => {
    const el = stickyTopRef.current;
    if (!el) return undefined;
    const page = el.closest(".stock-take-page");
    const apply = () => {
      if (!page) return;
      page.style.setProperty(
        "--report-sticky-block-height",
        `${el.offsetHeight}px`,
      );
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, [locationOnSecondRow, rfidIntegrate]);

  const syncStockTakeTableScroll = (source) => {
    if (tableScrollSyncLock.current) return;
    const head = tableHeadScrollRef.current;
    const body = tableBodyScrollRef.current;
    if (!head || !body) return;
    tableScrollSyncLock.current = true;
    if (source === "head") {
      body.scrollLeft = head.scrollLeft;
    } else {
      head.scrollLeft = body.scrollLeft;
    }
    requestAnimationFrame(() => {
      tableScrollSyncLock.current = false;
    });
  };

  useEffect(() => {
    let frame = 0;
    const syncStockTakeTableWidths = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const headTable = tableHeadTableRef.current;
        const bodyTable = tableBodyTableRef.current;
        if (!headTable || !bodyTable) return;

        const headThs = headTable.querySelectorAll("thead th");
        const bodyRow = bodyTable.querySelector("tbody tr");
        const count = headThs.length;
        if (!count) return;

        headTable.style.width = "max-content";
        bodyTable.style.width = "max-content";
        headTable.style.tableLayout = "auto";
        bodyTable.style.tableLayout = "auto";
        headThs.forEach((th) => {
          th.style.width = "";
          th.style.minWidth = "";
          th.style.maxWidth = "";
        });
        bodyTable.querySelectorAll("td, th").forEach((cell) => {
          cell.style.width = "";
          cell.style.minWidth = "";
          cell.style.maxWidth = "";
        });

        const widths = [];
        for (let i = 0; i < count; i += 1) {
          const hw = headThs[i].getBoundingClientRect().width;
          const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
          widths.push(Math.ceil(Math.max(hw, bw, 40)));
        }
        let total = widths.reduce((sum, w) => sum + w, 0);
        const containerWidth = Math.floor(
          tableBodyScrollRef.current?.clientWidth ||
            tableHeadScrollRef.current?.clientWidth ||
            0,
        );
        // Fill remaining page width so the table isn't left-shrunk with empty space
        if (containerWidth > total && total > 0) {
          const scale = containerWidth / total;
          let used = 0;
          for (let i = 0; i < count; i += 1) {
            if (i === count - 1) {
              widths[i] = Math.max(widths[i], containerWidth - used);
            } else {
              widths[i] = Math.max(1, Math.floor(widths[i] * scale));
              used += widths[i];
            }
          }
          total = containerWidth;
        }
        headTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        headTable.style.width = `${total}px`;
        bodyTable.style.width = `${total}px`;

        for (let i = 0; i < count; i += 1) {
          const widthPx = `${widths[i]}px`;
          headThs[i].style.width = widthPx;
          headThs[i].style.minWidth = widthPx;
          headThs[i].style.maxWidth = widthPx;
          bodyTable
            .querySelectorAll(`tr > :nth-child(${i + 1})`)
            .forEach((cell) => {
              cell.style.width = widthPx;
              cell.style.minWidth = widthPx;
              cell.style.maxWidth = widthPx;
            });
        }

        (newcolumndata || []).forEach((col, index) => {
          const hide = col?.status === false;
          headThs[index]?.classList.toggle("d-none", hide);
          bodyTable
            .querySelectorAll(`tr > :nth-child(${index + 1})`)
            .forEach((cell) => {
              cell.classList.toggle("d-none", hide);
            });
        });
      });
    };

    syncStockTakeTableWidths();
    window.addEventListener("resize", syncStockTakeTableWidths);
    const observer = new ResizeObserver(syncStockTakeTableWidths);
    if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
    if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", syncStockTakeTableWidths);
      observer.disconnect();
    };
  }, [reportstocktakelist, newcolumndata, datalodaer]);

  const downloadexclsheet = async () => {
    let header_values = [];
    let bodyarray = [];
    reportstocktakelisthead.map(async (r, k) => {
      header_values.push(r?.lable);
    });
    if (reportstocktakelist.length) {
      reportstocktakelist.forEach((result, key) => {
        bodyarray.push([
          key + 1,
          formatStockTakeDateTime(result?.date, result?.time),
          result?.ref,
          result?.location,
          result?.total,
          result?.scanned,
          result?.unscanned,
          result?.conflictAndUnknown,
          result?.user_name,
          result?.pdf,
        ]);
      });
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(bodyarray, {
      origin: "A2",
      skipHeader: true,
    });
    XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: "A1" });
    XLSX.utils.book_append_sheet(wb, ws, "Records");
    const fileContent = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([fileContent], { type: fileType });
    FileSaver.saveAs(data, "report_stocktake");
  };
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];
  return (
    <React.Fragment>
      <div className="main-body report-page stock-take-page product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="sticky-top-stock-take-page" ref={stickyTopRef}>
              <h2 className="main-body-heading">
                <span>
                  {t("report")} {">"}
                </span>
                &nbsp;&nbsp;{t("Stock Take")}
              </h2>
              <div className="main-body-top-inventory">
                <div className="main-body-top-inventory-status">
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/location.png"}
                        className="inventory-img"
                        alt="value"
                      />
                    </div>
                    <div className="right-side">
                      <span className="inventory-name">{t("Location")}</span>
                      <h2 className="inventory-value location">
                        {reportstockcounts?.locationCount
                          ? reportstockcounts?.locationCount
                          : ""}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/customer.png"}
                        className="inventory-img"
                        alt="free-stock"
                      />
                    </div>
                    <div className="right-side">
                      <span className="inventory-name">{t("User")}</span>
                      <h2 className="inventory-value value">
                        {reportstockcounts?.countuser
                          ? reportstockcounts?.countuser
                          : ""}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="stock-take-status-wrap">
                <div className="main-body-top-status-bar" style={{ zIndex: 2 }}>
                  <ReportMenuModal />
                  <Select
                    className="limit-select short z-10"
                    options={selectOptions}
                    value={{ label: limit, value: limit }}
                    onChange={(e) => {
                      setLimit(e.value);
                      getlimit(e.value);
                    }}
                  />
                  <div className="main-body-top-status-bar-filter">
                    <input
                      value={filtername}
                      type="text"
                      className="main-body-top-status-bar-filter-input"
                      placeholder={t(
                        // "Product name/Stock Id/SKU/Customer/Barcode",
                        "Search by Location",
                      )}
                      onKeyPress={(e) =>
                        e.key === "Enter" && filterbyname(e.target.value)
                      }
                      onChange={(e) => setFiltername(e.target.value)}
                    />
                    {filtername ? (
                      <img
                        className="main-body-top-status-bar-filter-clear"
                        src={base_assets + "images/icons/False.png"}
                        onClick={(e) => {
                          setFiltername("");
                          filterbyname("");
                        }}
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                    <button
                      onClick={() => filterbyname(filtername)}
                      className="main-body-top-status-bar-filter-search"
                    >
                      <i className="fa fa-search" aria-hidden="true" />
                    </button>
                  </div>
                  {rfidIntegrate && (
                    <div
                      ref={locationInlineSlotRef}
                      className={`stock-take-location-inline${locationOnSecondRow ? " is-placeholder" : ""}`}
                    >
                      {!locationOnSecondRow ? (
                        <div className="product-multi-select stock-take-location-select">
                          <svg
                            width="14"
                            height="18"
                            viewBox="0 0 14 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.00001 17C7.00001 17 13.2609 11.4348 13.2609 7.26087C13.2609 3.80309 10.4578 1 7.00001 1C3.54222 1 0.739136 3.80309 0.739136 7.26087C0.739136 11.4348 7.00001 17 7.00001 17Z"
                              stroke="#A4A4A4"
                            />
                            <path
                              d="M9.00026 7.00013C9.00026 8.1047 8.10483 9.00013 7.00026 9.00013C5.89569 9.00013 5.00026 8.1047 5.00026 7.00013C5.00026 5.89556 5.89569 5.00013 7.00026 5.00013C8.10483 5.00013 9.00026 5.89556 9.00026 7.00013Z"
                              stroke="#A4A4A4"
                            />
                          </svg>
                          <div className="product-multi-select-box">
                            <StockTakeLocationSelect
                              value={selectedLocations}
                              onChange={setSelectedLocations}
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                  <div className="main-body-top-status-bar-multi-date-picker">
                    {rfidIntegrate && (
                      <>
                        <button
                          type="button"
                          className="com-plus-text-btn text-white text-center fw-semibold d-flex align-items-center border-0 rounded-1 stock-take-rfid-btn"
                          onClick={() => {
                            !syncRfidLoading && handleSyncRfid();
                          }}
                          disabled={syncRfidLoading}
                          style={{
                            opacity: syncRfidLoading ? 0.7 : 1,
                            background: "transparent",
                          }}
                        >
                          <div
                            className="kycTooltip-area-up"
                            style={{
                              width: "auto",
                              height: "auto",
                              marginTop: 0,
                            }}
                          >
                            <RFIDIcon />
                            <span
                              className="kycTooltip-area-up-text"
                              style={{
                                zIndex: 999,
                                textWrapMode: "wrap",
                                fontSize: "12px",
                                width: "250px",
                                whiteSpace: "normal",
                              }}
                            >
                              {"RFID"} <br />
                              <span style={{ fontSize: "11px" }}>
                                {
                                  "Select the locations and date range, then click the RFID icon to fetch stock take details. Existing records in the table will be skipped, and only new records will be added."
                                }
                              </span>
                            </span>
                          </div>
                        </button>
                        {/* <button
                        type="button"
                        className="com-plus-text-btn text-white text-center fw-semibold d-flex align-items-center border-0 rounded-1 stock-take-rfid-btn"
                        style={{backgroundColor: 'transparent'}}
                     >
                          <div
                            className="kycTooltip-area-up"
                            style={{ width: "auto", height: "auto", marginTop: '2px',
                              backgroundColor: 'transparent', color: '#606060',border:'1px solid #606060',
                              fontSize: '12px',
                            padding: '0 8px',borderRadius: '50px',
                             }}
                          >
                          i
                            <span className="kycTooltip-area-up-text" style={{ zIndex: 999,    textWrapMode: 'wrap',
    width: '250px',whiteSpace: 'normal' }}>
                              {"Select the locations and date range, then click the RFID icon to fetch stock take details. Existing records in the table will be skipped, and only new records will be added."}
                            </span>
                          </div>
                        </button> */}
                      </>
                    )}
                    <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
                      <button
                        className="dropdown-toggle btn-style align-items-center d-flex"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                            stroke="currentcolor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {t(datelable)}
                      </button>
                      <ul className="dropdown-menu dropdown-menu-right-fix">
                        <li
                          className={`dropdown-item ${datelable === "Today" ? "active" : ""}`}
                          onClick={() => changeDates("Today")}
                        >
                          {t("Today")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "Yesterday" ? "active" : ""}`}
                          onClick={() => changeDates("Yesterday")}
                        >
                          {t("Yesterday")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "7days" ? "active" : ""}`}
                          onClick={() => changeDates("7days")}
                        >
                          {t("Last 7 days")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "30days" ? "active" : ""}`}
                          onClick={() => changeDates("30days")}
                        >
                          {t("Last 30 days")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "ThisMonth" ? "active" : ""}`}
                          onClick={() => changeDates("ThisMonth")}
                        >
                          {t("This Month")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "LastMonth" ? "active" : ""}`}
                          onClick={() => changeDates("LastMonth")}
                        >
                          {t("Last Month")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "Custom Range" ? "active" : ""}`}
                          onClick={() => datePickerRef.current.setOpen(true)}
                        >
                          {t("Custom Range")}
                        </li>
                      </ul>
                      <DatePicker
                        selectsRange={true}
                        monthsShown={2}
                        startDate={datefilter[0]}
                        endDate={datefilter[1]}
                        onChange={(update) => {
                          const s = update[0],
                            e = update[1];
                          setDatelable("Custom Range");
                          if (s && e) {
                            const ms = new Date(s);
                            ms.setHours(0, 0, 0, 0);
                            const me = new Date(e);
                            me.setHours(23, 59, 59, 999);
                            setDatefilter([ms, me]);
                          } else {
                            setDatefilter([s, e]);
                          }
                        }}
                        dateFormat="yyyy-MM-dd"
                        ref={datePickerRef}
                        autoComplete="none"
                      />
                    </div>
                    <button className="print-export-dropdown-selected-icon d-none">
                      <img
                        src={base_assets + "images/icons/printer-icon.png"}
                        alt=""
                      />
                    </button>
                    <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={
                            base_assets + "images/icons/ellipsis-circular.png"
                          }
                          alt=""
                        />
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          className={
                            parmissiondatashow?.inventory_reports?.Print
                              ? "dropdown-item print-dropdown-item"
                              : "d-none"
                          }
                          onClick={(e) => {
                            getprintstocktake(e.target.value);
                          }}
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={
                                base_assets + "images/icons/printer-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          <span>{t("print")}</span>
                        </li>
                        <li
                          className="dropdown-item"
                          onClick={(e) => {
                            downloadexclsheet(e.target.value);
                          }}
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={
                                base_assets + "images/icons/export-x-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          <span>{t("export")}</span>
                        </li>

                        <li
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#socialModal"
                          onClick={() => getsharestocktake()}
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={base_assets + "images/icons/share-icon.png"}
                              alt=""
                            />
                          </div>
                          <span>{t("share")}</span>
                        </li>

                        <li
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#columnModal"
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={base_assets + "images/icons/column-icon.png"}
                              alt=""
                            />
                          </div>
                          <span>{t("column")}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {locationOnSecondRow ? (
                  <div
                    className="stock-take-location-row"
                    style={{ zIndex: 4 }}
                  >
                    <div className="product-multi-select stock-take-location-select is-full-width">
                      <svg
                        width="14"
                        height="18"
                        viewBox="0 0 14 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.00001 17C7.00001 17 13.2609 11.4348 13.2609 7.26087C13.2609 3.80309 10.4578 1 7.00001 1C3.54222 1 0.739136 3.80309 0.739136 7.26087C0.739136 11.4348 7.00001 17 7.00001 17Z"
                          stroke="#A4A4A4"
                        />
                        <path
                          d="M9.00026 7.00013C9.00026 8.1047 8.10483 9.00013 7.00026 9.00013C5.89569 9.00013 5.00026 8.1047 5.00026 7.00013C5.00026 5.89556 5.89569 5.00013 7.00026 5.00013C8.10483 5.00013 9.00026 5.89556 9.00026 7.00013Z"
                          stroke="#A4A4A4"
                        />
                      </svg>
                      <div className="product-multi-select-box">
                        <StockTakeLocationSelect
                          value={selectedLocations}
                          onChange={setSelectedLocations}
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative stock-take-table-wrap"
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  overflow: "visible",
                }}
              >
                <div className="stock-take-sticky-thead">
                  <div
                    className="stock-take-table-hscroll stock-take-table-hscroll--head"
                    ref={tableHeadScrollRef}
                    onScroll={() => syncStockTakeTableScroll("head")}
                  >
                    <table
                      ref={tableHeadTableRef}
                      className="stripe row-border order-column common-table table-striped main-table stock-take-head-table"
                    >
                      <Tablehead
                        tablehead={newcolumndata}
                        tblName={"tbl_report_stocktake"}
                        setfilterby={""}

                        onSort={reportSort.handleSort}

                        sortConfig={reportSort.sortConfig}
                      />
                    </table>
                  </div>
                </div>
                <div
                    className="stock-take-table-hscroll stock-take-table-hscroll--body"
                    ref={tableBodyScrollRef}
                    onScroll={() => syncStockTakeTableScroll("body")}
                  >
                  <table
                    id="report_stocktake"
                    ref={tableBodyTableRef}
                    className="stripe row-border order-column common-table table-striped main-table stock-take-report-table"
                  >
                    <tbody>
                      <>
                        {reportstocktakelist
                          ? reportSort.sortedList.map((result, key) => {
                              const countryCode =
                                getStockTakeCountryCode(result);
                              const { date: displayDate, time: displayTime } =
                                formatStockTakeDateTimeParts(
                                  result?.date,
                                  result?.time,
                                );
                              return (
                                <tr className="" key={key}>
                                  <td className="fixed-side">{(currentPage - 1) * (Number(limit) || 0) + key + 1}</td>
                                  <td className="fixed-side">
                                    <span>
                                      {displayDate}
                                      {displayTime ? (
                                        <>
                                          ,{" "}
                                          <span style={{ fontSize: "14px" }}>
                                            {displayTime}
                                          </span>
                                        </>
                                      ) : null}{" "}
                                      {countryCode ? (
                                        <span className="badge bg-danger rounded-1">
                                          {countryCode}
                                        </span>
                                      ) : null}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      width: "20px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {" "}
                                    {result?.rfid && (
                                      <div
                                        style={{
                                          width: "auto",
                                          height: "auto",
                                          cursor: "pointer",
                                        }}
                                        onMouseEnter={(e) => {
                                          const rect =
                                            e.currentTarget.getBoundingClientRect();
                                          setSourceTooltip({
                                            x: rect.left + rect.width / 2,
                                            y: rect.top,
                                            label: t("RFID"),
                                          });
                                        }}
                                        onMouseLeave={() =>
                                          setSourceTooltip(null)
                                        }
                                      >
                                        <RFIDIcon width={16} height={16} />
                                      </div>
                                    )}
                                    {result?.from === "mobile" && (
                                      <div
                                        style={{
                                          width: "auto",
                                          height: "auto",
                                          cursor: "pointer",
                                        }}
                                        onMouseEnter={(e) => {
                                          const rect =
                                            e.currentTarget.getBoundingClientRect();
                                          setSourceTooltip({
                                            x: rect.left + rect.width / 2,
                                            y: rect.top,
                                            label: t("Mobile"),
                                          });
                                        }}
                                        onMouseLeave={() =>
                                          setSourceTooltip(null)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="14"
                                          height="14"
                                          viewBox="0 0 14 14"
                                          fill="none"
                                        >
                                          <path
                                            d="M6.125 0.875H4.8125C4.08763 0.875 3.5 1.46263 3.5 2.1875V11.8125C3.5 12.5374 4.08763 13.125 4.8125 13.125H9.1875C9.91237 13.125 10.5 12.5374 10.5 11.8125V2.1875C10.5 1.46263 9.91237 0.875 9.1875 0.875H7.875M6.125 0.875V1.75H7.875V0.875M6.125 0.875H7.875M6.125 11.8125H7.875"
                                            stroke="#606060"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </div>
                                    )}
                                    {result?.manual && (
                                      <div
                                        style={{
                                          width: "auto",
                                          height: "auto",
                                          cursor: "pointer",
                                        }}
                                        onMouseEnter={(e) => {
                                          const rect =
                                            e.currentTarget.getBoundingClientRect();
                                          setSourceTooltip({
                                            x: rect.left + rect.width / 2,
                                            y: rect.top,
                                            label: t("Manual"),
                                          });
                                        }}
                                        onMouseLeave={() =>
                                          setSourceTooltip(null)
                                        }
                                      >
                                        <img
                                          src={manualScan}
                                          alt="manual"
                                          style={{
                                            width: "16px",
                                            height: "16px",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </td>
                                  <td className="fixed-side link-color">
                                    {result?.st_no}
                                  </td>
                                  <td className="fixed-side">
                                    {result?.location}
                                  </td>
                                  <td className="fixed-side yellow-text">
                                    {result?.total}
                                  </td>
                                  <td className="fixed-side jewelry-color-text">
                                    {result?.scanned}
                                  </td>
                                  <td className="fixed-side stock-take-green-text">
                                    {result?.unscanned}
                                  </td>
                                  <td className="fixed-side blue-navy-text">
                                    {result?.conflictAndUnknown}
                                  </td>
                                  <td className="fixed-side">
                                    {result?.user_name}
                                  </td>
                                  <td className="text-center">
                                    {result?.pdf ? (
                                      <div
                                        onClick={() => {
                                          if (result?.pdf) {
                                            window.open(
                                              result?.pdf,
                                              "_blank",
                                              "noreferrer",
                                            );
                                          }
                                        }}
                                      >
                                        <img
                                          className="pdf-image"
                                          src={
                                            base_assets +
                                            "images/icons/pdf-icon.png"
                                          }
                                          alt=""
                                        />
                                      </div>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          : ""}
                      </>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td />
                        <td />
                        <td style={{ width: "20px", textAlign: "center" }} />
                        <td />
                        <td />
                        <td>
                          {" "}
                          {reportstocktakelist
                            ? reportstocktakelist?.reduce(
                                (interation, val) =>
                                  (interation =
                                    interation + parseInt(val.total)),
                                0,
                              )
                            : ""}
                        </td>
                        <td>
                          {" "}
                          {reportstocktakelist
                            ? reportstocktakelist?.reduce(
                                (interation, val) =>
                                  (interation =
                                    interation + parseInt(val.scanned)),
                                0,
                              )
                            : ""}
                        </td>
                        <td>
                          {" "}
                          {reportstocktakelist
                            ? reportstocktakelist?.reduce(
                                (interation, val) =>
                                  (interation =
                                    interation + parseInt(val.unscanned)),
                                0,
                              )
                            : ""}
                        </td>
                        <td>
                          {" "}
                          {reportstocktakelist
                            ? reportstocktakelist?.reduce(
                                (interation, val) =>
                                  (interation =
                                    interation +
                                    parseInt(val.conflictAndUnknown)),
                                0,
                              )
                            : ""}
                        </td>
                        <td></td>
                        <td />
                      </tr>
                    </tfoot>
                  </table>
                  </div>
                  <div
                    id="table_loader"
                    className={datalodaer ? "mt-4" : "d-none"}
                  >
                    <div className="dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
              </div>
              {reportstocktakelist?.length > 0 ? (
                <Pagination
                  total={totalPages}
                  current={currentPage}
                  pagination={(crPage) => handlePaginations(crPage)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <SocialModal shareUrl={socialurl} shareloader={shareloader} />
      </div>
      {sourceTooltip &&
        createPortal(
          <span
            style={{
              position: "fixed",
              left: sourceTooltip.x,
              top: sourceTooltip.y - 8,
              transform: "translate(-50%, -100%)",
              zIndex: 9999,
              minWidth: "80px",
              padding: "6px 11px",
              borderRadius: "3px",
              backgroundColor: "#fff",
              color: "#606060",
              boxShadow: "0px 0px 10px #80808085",
              whiteSpace: "nowrap",
              lineHeight: "normal",
              textAlign: "center",
              letterSpacing: "0.3px",
              fontSize: "12px",
              pointerEvents: "none",
            }}
          >
            {sourceTooltip.label}
            <span
              style={{
                width: "6px",
                height: "6px",
                background: "#fff",
                position: "absolute",
                left: "50%",
                bottom: "-3px",
                transform: "translateX(-50%) rotate(45deg)",
              }}
            />
          </span>,
          document.body,
        )}
      <TableColumnModal
        tablehead={reportstocktakelisthead}
        tblName={"tbl_report_stocktake"}
        setnewcolumndata={setnewcolumndata}
        calldatatable={Getreportstocktake}
      ></TableColumnModal>
    </React.Fragment>
  );
};
export default Stocktakereport;
